import { useLayoutEffect, type RefObject } from 'react';

/** Keeps mention assist panel above DevExtreme Chat message box (measured height → CSS var). */
export function useChatComposeStackOffset(
  hostRef: RefObject<HTMLElement | null>,
  enabled: boolean
): void {
  useLayoutEffect(() => {
    const host = hostRef.current;
    if (!host || !enabled) return;

    const sync = () => {
      const box = host.querySelector('.dx-chat-messagebox');
      const boxHeight =
        box instanceof HTMLElement ? Math.ceil(box.getBoundingClientRect().height) : 0;
      const toolbar = host.querySelector('.discussion-compose-toolbar');
      const toolbarHeight =
        toolbar instanceof HTMLElement ? Math.ceil(toolbar.getBoundingClientRect().height) : 0;
      const height = boxHeight + toolbarHeight;
      if (height > 0) {
        host.style.setProperty('--file-review-chat-compose-stack-height', `${height}px`);
        host.style.setProperty('--file-review-chat-messagebox-height', `${boxHeight}px`);
      }
    };

    sync();
    const box = host.querySelector('.dx-chat-messagebox');
    const observer =
      box instanceof HTMLElement
        ? new ResizeObserver(() => sync())
        : null;
    if (box instanceof HTMLElement) observer?.observe(box);

    const mutation = new MutationObserver(() => sync());
    mutation.observe(host, { childList: true, subtree: true });

    return () => {
      observer?.disconnect();
      mutation.disconnect();
    };
  }, [enabled, hostRef]);
}
